import { render, staticRenderFns } from "./OtoPageTitle.vue?vue&type=template&id=2138dfc2&scoped=true"
import script from "./OtoPageTitle.vue?vue&type=script&lang=js"
export * from "./OtoPageTitle.vue?vue&type=script&lang=js"
import style0 from "./OtoPageTitle.vue?vue&type=style&index=0&id=2138dfc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138dfc2",
  null
  
)

export default component.exports